module.exports = __webpack_public_path__ + "media/images/countryrect/ci-039d4dff509dbf6d90d575799c6142d5.svg";